import axios from "axios";

export class HttpHandler {
    createInstance (baseUrl) {
        //TODO. Acá va a traer el token "real" este split va a desaparecer.
        // Así como el header que actualmente se manda, se mandará el header token
        const instance = axios.create({
            baseURL: baseUrl,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("accessToken"),
            }
        });
        instance.interceptors.response.use(function onFulfilled(response) {
            return response;
        }, function onRejected(error) {
            if (hasSession(error)) {
                let data = error.response.data
                if(data.message === undefined || data.message === 'Not Found') {
                    error.response['message'] = 'Servicio no disponible';
                    error.response['debugMessage'] = '';
                    return error.response;
                }
                return error.response.data;
            } else {
                endSession();
            }
        });
        return instance;
    }
}

export function hasSession(error){
    const {status, data} = error.response;
    return !(status === 403 && data.message.includes('Forbidden'));
}

export function endSession() {
    alert('No existe Sesión');
    localStorage.clear();
    window.location.reload();
}
